export function getCheckedNumbers(numbersObject: {[key: number]: boolean}): number[] {
    return Object.keys(numbersObject)
        .filter((number) => numbersObject[number])
        .map((number) => Number(number));
}
